import { render, staticRenderFns } from "./miniappspecialsubjectlist.vue?vue&type=template&id=a13c91b6&scoped=true"
import script from "./miniappspecialsubjectlist.vue?vue&type=script&lang=js"
export * from "./miniappspecialsubjectlist.vue?vue&type=script&lang=js"
import style0 from "./miniappspecialsubjectlist.vue?vue&type=style&index=0&id=a13c91b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13c91b6",
  null
  
)

export default component.exports